<template>
  <div class="orderPage">
    <!-- <div class="search_wrap flex-between">
      <van-field v-model="params.order_id" placeholder="输入订单号查找→" />
      <div class="search_btn flex-rowc" @click="handleSearch">
        <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div> -->
    <div class="select_wrap flex-between">
      <!-- <div class="select_item flex-between" @click="handleShow(1)">
        <span>{{ orserState }}</span>
        <i class="iconfont icon-toTop"></i>
      </div>
      <div class="select_item flex-between" @click="handleShow(2)">
        <span>{{ orderProperty }}</span>
        <i class="iconfont icon-toTop"></i>
      </div> -->
      <div class="dropdown_wrap">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="params.service_order_status"
            :options="serviceOrderState"
            @change="changeDropdownStatus"
          />
          <van-dropdown-item
            v-model="params.service_order_property"
            :options="serviceOrderProperty"
            @change="changeDropdownProperty"
          />
        </van-dropdown-menu>
      </div>

      <div class="search_btn flex-rowc" @click="isShowPopup = true">
        查找订单 <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div>
    <div class="flex-between">
      <div class="radio_wrap flex-rowc">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#ee0a24"
          @change="changeCheck"
        ></van-checkbox>
        <span>按筛选条件只看今天的订单</span>
      </div>
      <div class="clear_condition" @click="handleClearParams">
        清空筛选条件
        <!-- 清空筛选条件（显示所有订单） -->
      </div>
    </div>
    <div class="order_num">查找到{{ total }}笔订单</div>
    <div class="order_wrap" @scroll="orderScroll($event)">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="list" v-if="dataList.length > 0">
          <div class="item" v-for="item in dataList" :key="item.id">
            <div class="block_one" @click="handleDetail(item.order_id)">
              <div class="column flex-rowl">
                <p class="label">创建时间：</p>
                <p class="con">{{ getTiemSplit(item.create_time) }}</p>
              </div>
              <div class="column flex-rowl">
                <p class="label">订单状态：</p>
                <p class="con">
                  {{ item.service_order_statusstr }}
                  <!-- {{
                    item.service_order_status == 1
                      ? "待接单"
                      : item.service_order_status == 2
                      ? "已接单"
                      : item.service_order_status == 3
                      ? "取餐中"
                      : item.service_order_status == 4
                      ? "送餐中"
                      : item.service_order_status == 5
                      ? "待自提"
                      : item.service_order_status == 6
                      ? "已送达"
                      : "已完成"
                  }} -->
                </p>
              </div>
              <div class="column flex-rowl">
                <p class="label">订单情况：</p>
                <p class="con">
                  {{
                    item.service_order_property == 1
                      ? "服务订单进行中"
                      : item.service_order_property == 2
                      ? "服务订单取消申请中"
                      : item.service_order_property == 3
                      ? "服务订单已取消"
                      : "服务订单已完成"
                  }}
                </p>
              </div>
            </div>
            <div class="block_two">
              <!-- <div class="column flex-between">
                <div
                  class="left flex-rowl"
                  @click="handleDetail(item.order_id)"
                >
                  <p class="label">服务订单号：</p>
                  <p class="con">
                    {{ item.service_order_id }}
                  </p>
                </div>
                <div
                  class="btn_copy code"
                  :data-clipboard-text="item.service_order_id"
                  @click="handleCopy()"
                >
                  <i class="iconfont icon-fuzhi"></i>
                </div>
              </div> -->
              <div class="column flex-between">
                <div
                  class="left flex-rowl"
                  @click="handleDetail(item.order_id)"
                >
                  <p class="label">订单号：</p>
                  <p class="con">
                    {{ item.order_id }}
                  </p>
                </div>
                <div
                  class="btn_copy code"
                  :data-clipboard-text="item.order_id"
                  @click="handleCopy()"
                >
                  <i class="iconfont icon-fuzhi"></i>
                </div>
              </div>
              <!-- <div
                class="column flex-rowl"
                @click="handleDetail(item.order_id)"
              >
                <p class="label">送餐位置：</p>
                <p class="con">{{ item.address_detail }}</p>
              </div> -->
              <div
                class="column flex-rowl"
                @click="handleDetail(item.order_id)"
              >
                <p class="label">送餐楼栋：</p>
                <p class="con">{{ item.buildingidstr }}</p>
              </div>
              <!-- <div
                class="column flex-rowl"
                @click="handleDetail(item.order_id)"
              >
                <p class="label">关联取餐柜：</p>
                <p class="con">{{ item.service_rating }}</p>
              </div> -->
              <div
                class="column flex-rowl"
                @click="handleDetail(item.order_id)"
              >
                <p class="label">用户姓名：</p>
                <p class="con">{{ item.truename }}</p>
              </div>
              <div
                class="column flex-rowl"
                @click="handleDetail(item.order_id)"
              >
                <p class="label">联系电话：</p>
                <p class="con">{{ item.customer_phone }}</p>
              </div>
              <div class="column order_content flex-rowl">
                <p class="label">订单内容：</p>
                <p class="con">{{ item.order_content }}</p>
              </div>
              <!-- 待接单、已接单状态 -->
              <div
                class="order_state_operation flex-rowr"
                v-if="
                  item.service_order_status == 1 ||
                  item.service_order_status == 2
                "
              >
                <div
                  class="btn flex-rowc"
                  :class="{ disabled: item.service_order_status == 2 }"
                  @click="
                    handleOrder(
                      item.service_order_status,
                      item.address_detail,
                      item.order_id
                    )
                  "
                >
                  {{
                    item.service_order_status == 1
                      ? "待接单"
                      : item.service_order_status == 2
                      ? "已接单"
                      : ""
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          description="暂无订单"
          v-if="!isLoading && dataList.length == 0"
        />
      </van-pull-refresh>
    </div>

    <!-- 详情弹窗 -->
    <van-overlay :show="isShow" :lock-scroll="false" z-index="100001">
      <div class="custom_popup">
        <div class="custom_close flex-rowc" @click="handleClosePopup">
          <span class="iconfont icon-jujueweituo"></span>
        </div>
        <div class="custom_popup_wrap">
          <div class="list">
            <div class="item">
              <div class="block_one">
                <div class="column flex-rowl">
                  <p class="label">创建时间：</p>
                  <p class="con">{{ dataItem.order_time }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">订单状态：</p>
                  <p class="con">
                    {{
                      dataItem.service_order_status == 1
                        ? "待接单"
                        : dataItem.service_order_status == 2
                        ? "已接单"
                        : dataItem.service_order_status == 3
                        ? "取餐中"
                        : dataItem.service_order_status == 4
                        ? "送餐中"
                        : dataItem.service_order_status == 5
                        ? "待自提"
                        : dataItem.service_order_status == 6
                        ? "已送达"
                        : "已完成"
                    }}
                  </p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">订单情况：</p>
                  <p class="con">
                    {{
                      dataItem.service_order_property == 1
                        ? "服务订单进行中"
                        : dataItem.service_order_property == 2
                        ? "服务订单取消申请中"
                        : dataItem.service_order_property == 3
                        ? "服务订单已取消"
                        : "服务订单已完成"
                    }}
                  </p>
                </div>
              </div>

              <div class="block_two">
                <div class="column flex-rowl">
                  <p class="label">服务订单号：</p>
                  <p class="con">{{ dataItem.service_order_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">订单号：</p>
                  <p class="con">{{ dataItem.order_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">送餐位置：</p>
                  <p class="con">{{ dataItem.address_detail }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">送餐楼栋：</p>
                  <p class="con">{{ dataItem.buildingidstr }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">关联取餐柜：</p>
                  <p class="con">{{ dataItem.service_rating }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">用户姓名：</p>
                  <p class="con">{{ dataItem.truename }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">联系电话：</p>
                  <p class="con">{{ dataItem.customer_phone }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">订单内容：</p>
                  <p class="con">{{ dataItem.order_content }}</p>
                </div>
              </div>

              <div class="block_three">
                <div class="column flex-rowl">
                  <p class="label">取餐员：</p>
                  <p class="con">{{ pickupInfo.pickup_staff_name }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">取餐员工号：</p>
                  <p class="con">{{ pickupInfo.pickup_staff_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">联系方式：</p>
                  <p class="con">{{ pickupInfo.pickup_staff_contact }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">取餐时间：</p>
                  <p class="con">{{ pickupInfo.pickup_time }}</p>
                </div>
              </div>

              <!-- <div class="block_three">
                <div class="column flex-rowl">
                  <p class="label">送餐员：</p>
                  <p class="con">{{ deliveryInfo.delivery_staff_name }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">送餐员工号：</p>
                  <p class="con">{{ deliveryInfo.delivery_staff_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">联系方式：</p>
                  <p class="con">{{ deliveryInfo.delivery_staff_contact }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">送餐时间：</p>
                  <p class="con">{{ deliveryInfo.delivery_assignment_time }}</p>
                </div>
              </div> -->

              <div class="block_three">
                <div class="column flex-rowl">
                  <p class="label">分派员：</p>
                  <p class="con">{{ serinfoInfo.dispatch_staff_name }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">分派员工号：</p>
                  <p class="con">{{ serinfoInfo.dispatch_staff_id }}</p>
                </div>
                <div class="column flex-rowl">
                  <p class="label">联系方式：</p>
                  <p class="con">{{ serinfoInfo.dispatch_staff_contact }}</p>
                </div>
                <div class="column dispath_type flex-rowl">
                  <p class="label">分派方式：</p>
                  <div class="con" v-if="serinfoInfo.dispatch_result">
                    <div class="block" v-if="serinfoInfo.dispatch_result == 4">
                      <p>直接送达用户</p>
                    </div>
                    <div
                      class="block"
                      v-else-if="serinfoInfo.dispatch_result == 1"
                    >
                      <p>已放入取餐柜</p>
                      <p>{{ serinfoInfo.locker_number }}</p>
                      <p>
                        {{ serinfoInfo.locker_compartment_number }} 格（大件用）
                      </p>
                      <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
                    </div>
                    <div
                      class="block"
                      v-else-if="serinfoInfo.dispatch_result == 2"
                    >
                      <p>已放入取餐柜</p>
                      <p>{{ serinfoInfo.locker_number }}</p>
                      <p>
                        {{ serinfoInfo.locker_compartment_number }} 格（小件用）
                      </p>
                      <p>{{ serinfoInfo.locker_code }}（开柜码）</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 选择类型弹窗 start -->
    <van-popup v-model="isShowPopup">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="btn_item flex-between" @click="handleShowTextArea(1)">
            <p>手动输入订单号</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
          <div class="btn_item flex-between" @click="handleShowTextArea(2)">
            <p>点餐用户手机号查询</p>
            <i class="iconfont icon-youjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopup = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 选择类型弹窗 end -->

    <!-- 输入框弹窗 start -->
    <van-popup v-model="isShowPopupTextarea">
      <div class="popup_container">
        <div class="popup_wrap">
          <div class="textarea_box" v-if="popupType == 1">
            <van-field
              type="textarea"
              v-model="params.order_id"
              placeholder="输入订单号"
            />
          </div>
          <div class="textarea_box" v-else>
            <van-field
              type="textarea"
              v-model="params.customer_phone"
              placeholder="输入手机号"
            />
          </div>
          <div class="custom_btn" @click="handleQuery">
            开始查找 <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
        <div class="close" @click="isShowPopupTextarea = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </van-popup>
    <!-- 输入框弹窗 end -->

    <!-- <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <template v-if="orderType == 1">
        <van-picker
          title="选择服务订单状态"
          show-toolbar
          @cancel="show = false"
          :columns="serviceOrderState"
          @confirm="onConfirmState"
        />
      </template>
      <template v-if="orderType == 2">
        <van-picker
          title="选择服务订单属性"
          show-toolbar
          @cancel="show = false"
          :columns="serviceOrderProperty"
          @confirm="onConfirmProperty"
        />
      </template>
    </van-popup> -->
  </div>
</template>

<script>
import {
  getOrderList,
  orderSendManage,
  getToken,
  getOrderInfo,
  getTakeMeal,
  getSendMeal,
} from "../api/api";
import Clipboard from "clipboard";

export default {
  name: "orderList",
  data() {
    return {
      isShowPopupTextarea: false,
      isShowPopup: false,
      popupType: 1,
      // role 职能身份  "1","综合服务人员"|"2","取餐员"|"3","送餐员"|"4","点位服务人员"|"5","派单管理员"
      show: false,
      // 服务订单状态
      serviceOrderState: [
        {
          text: "所有状态订单",
          value: "",
        },
        {
          text: "待接单",
          value: 1,
        },
        {
          text: "已接单",
          value: 2,
        },
        {
          text: "已取餐",
          value: 3,
        },
        {
          text: "送餐中",
          value: 4,
        },
        {
          text: "待自提（已放入餐柜）",
          value: 5,
        },
        {
          text: "已送达（直达/或送至自提点）",
          value: 6,
        },
        {
          text: "已完成",
          value: 7,
        },
      ],
      // 服务订单属性
      serviceOrderProperty: [
        {
          text: "所有情况订单",
          value: "",
        },
        {
          text: "服务订单进行中",
          value: 1,
        },
        {
          text: "服务订单已取消（已退款）",
          value: 2,
        },
        {
          text: "服务订单已取消",
          value: 3,
        },
        {
          text: "服务订单已完成",
          value: 4,
        },
      ],

      checked: true,
      orderType: 1,
      orserState: "所有状态订单",
      orderProperty: "所有情况订单",
      params: {
        Page: 1,
        token: "",
        PageSize: 20,
        order_id: "",
        service_order_status: "",
        service_order_property: "",
        istoday: 1, // 1 是 0 否
        customer_phone: "",
      },

      isLoading: true,
      total: 0,
      dataList: [],

      dept: "",
      userInfo: "",

      isShow: false,
      dataItem: "", // 订单信息
      pickupInfo: "", // 取餐信息
      deliveryInfo: "", // 送餐信息
      serinfoInfo: "",
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    this.userInfo = userInfo;
    if (userInfo.dept.length > 0) {
      this.dept = userInfo.dept[0];
    }
    this.getToken();
  },
  computed: {
    getTiemSplit() {
      return function (data) {
        // let newData = data.split('T')[0] + ' ' + data.split('T')[1]
        let newData = data.replace("T", " ");
        return newData;
      };
    },
  },
  methods: {
    handleShowTextArea(type) {
      this.isShowPopup = false;
      this.isShowPopupTextarea = true;
      this.popupType = type;
    },
    handleQuery() {
      this.params.Page = 1;
      this.dataList = [];
      this.isShowPopupTextarea = false;
      this.getToken();
    },

    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          this.getOrderList();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },
    onRefresh() {
      this.params.Page = 1;
      this.getOrderList(true);
    },
    //
    getOrderList(isRefresh) {
      let { params } = this;
      let toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderList(params).then((res) => {
        if (res.error_code == 0) {
          if (isRefresh) {
            this.params.Page = 1;
            this.dataList = [];
          }
          this.total = res.data.total;
          this.dataList = this.dataList.concat(...res.data.list);
          this.isLoading = false;
        } else {
          this.dataList = [];
        }

        toast.clear();
      });
    },

    // 查看取餐订单
    getOrderInfo(order_id, token) {
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderInfo({ order_id, token }).then((res) => {
        if (res.error_code == 0) {
          if (Object.values(res.data).length != 0) {
            this.dataItem = res.data;
            this.pickupInfo = res.data.pickup;
            this.deliveryInfo = res.data.delivery;
            this.serinfoInfo =
              Object.values(res.data.serinfo).length != 0
                ? res.data.serinfo
                : "";
          } else {
            this.dataItem = "";
          }
          this.isShow = true;
          toast.clear();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
          this.isShow = false;
          toast.clear();
        }
      });
    },

    // 滚动事件
    orderScroll(e) {
      let el = e.target;
      //判断是否到达div容器底部
      let { total, dataList } = this;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        // if (listTotal > dataList.length) {
        //   this.params.Page += 1;
        //   this.initData();
        // }
        if (total > dataList.length) {
          this.params.Page += 1;
          this.getOrderList();
        }
      }
    },
    handleShow(type) {
      this.orderType = type;
      this.show = true;
    },
    handleSearch() {
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeCheck(e) {
      this.params.istoday = e ? 1 : 0;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeDropdownStatus(e) {
      console.log(e, "=========");
      this.params.service_order_status = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    changeDropdownProperty(e) {
      console.log(e, "=========");
      this.params.service_order_property = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    // onConfirmState(e) {
    //   let { text, value } = e;
    //   this.orserState = text;
    //   this.params.service_order_status = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    // onConfirmProperty(e) {
    //   let { text, value } = e;
    //   this.orderProperty = text;
    //   this.params.service_order_property = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    handleClearParams() {
      this.params.order_id = "";
      this.params.customer_phone = "";
      this.params.service_order_status = "";
      this.params.service_order_property = "";
      (this.orserState = "所有状态订单"),
        (this.orderProperty = "所有情况订单"),
        (this.params.istoday = 0);
      this.params.Page = 1;
      this.dataList = [];
      this.getOrderList();
    },
    /**
     * 复制功能
     */
    handleCopy() {
      var clipboard = new Clipboard(".code");
      console.log(clipboard, "=====clipboard");
      clipboard.on("success", (e) => {
        console.log("复制成功", e);
        this.$toast({
          message: "复制成功",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast({
          message: "手机权限不支持复制功能",
        });
        console.log("该浏览器不支持自动复制", e);
        // 释放内存
        clipboard.destroy();
      });
    },
    handleDetail(id) {
      // this.$router.push(`/orderIndex/orderDetail/${id}`);

      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.getOrderInfo(id, res.data.token);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 触发接单事件
    handleOrder(state, address_detail, order_id) {
      // state=2 已接单
      // let that = this;
      if (state == 2) return;
      this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        duration: 0,
      });
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.getTakeSendMeal(order_id, address_detail, res.data.token);
          // console.log(address_detail, "====");
          // orderSendManage({
          //   token: res.data.token,
          //   order_id,
          //   get_staff_id: this.userInfo.openid,
          // }).then((res1) => {
          //   if (res1.error_code == 0) {
          //     // this.$toast.success("接单成功");
          //     // this.params.token = res.data.token;
          //     // setTimeout(() => {
          //     //   this.params.Page = 1;
          //     //   that.getOrderList(true);
          //     // }, 800);
          //     setTimeout(() => {
          //       this.getTakeMeal(res.data.token);
          //     }, 600);
          //   } else {
          //     this.$toast.fail(res.message || "接口失效，请稍后～");
          //   }
          // });
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 提交取餐
    getTakeMeal(token) {
      let { dataItem, userInfo } = this;
      let order_id = dataItem.order_id;
      let params = {
        order_id,
        token,
        pickup_staff_name: userInfo.truename,
        pickup_staff_id: userInfo.accountid,
        pickup_staff_contact: userInfo.mobile,
      };
      getTakeMeal(params).then((res) => {
        if (res.error_code == 0) {
          // this.$toast.success(res.message);
          // toast.clear();
          // setTimeout(() => {
          //   this.getOrderInfo(order_id, token);
          // }, 500);
          setInterval(() => {
            this.getSendMeal(token);
          }, 600);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 提交送餐
    getSendMeal(token) {
      let { dataItem, userInfo } = this;
      let order_id = dataItem.order_id;
      // this.$toast.loading({
      //   message: "请稍后...",
      //   forbidClick: true,
      //   duration: 0,
      // });
      let params = {
        order_id,
        token,
        delivery_staff_name: userInfo.truename,
        delivery_staff_id: userInfo.accountid,
        delivery_staff_contact: userInfo.mobile,
        current_location: dataItem.address_detail,
      };
      getSendMeal(params).then((res) => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.params.Page = 1;
            this.getOrderList(true);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 根据需求调整，接单-取餐-送餐合并
    async getTakeSendMeal(order_id, address_detail, token) {
      let { userInfo } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        duration: 0,
      });
      // 1、接单
      let sendParams = {
        token: token,
        order_id,
        get_staff_id: this.userInfo.openid,
      };
      let res3 = await orderSendManage(sendParams);
      if (res3.error_code == 0) {
        // 2、取餐
        let takeParams = {
          order_id,
          token,
          pickup_staff_name: userInfo.truename,
          pickup_staff_id: userInfo.accountid,
          pickup_staff_contact: userInfo.mobile,
        };
        let res1 = await getTakeMeal(takeParams);
        if (res1.error_code == 0) {
          toast.clear();
          this.$toast.success(res1.message || "接口失效，请稍后～");
          setTimeout(() => {
            this.params.Page = 1;
            this.getOrderList(true);
          }, 500);

          // 3、送餐
          // let sendParams = {
          //   order_id,
          //   token,
          //   delivery_staff_name: userInfo.truename,
          //   delivery_staff_id: userInfo.accountid,
          //   delivery_staff_contact: userInfo.mobile,
          //   current_location: address_detail,
          // };
          // let res2 = await getSendMeal(sendParams);
          // if (res2.error_code == 0) {
          //   toast.clear();
          //   this.$toast.success(res2.message || "接口失效，请稍后～");
          //   setTimeout(() => {
          //     this.params.Page = 1;
          //     this.getOrderList(true);
          //   }, 500);
          // } else {
          //   this.$toast.fail(res2.message || "接口失效，请稍后～");
          //   setTimeout(() => {
          //     this.params.Page = 1;
          //     this.getOrderList(true);
          //   }, 500);
          // }
        } else {
          this.$toast.fail(res1.message || "接口失效，请稍后～");
          setTimeout(() => {
            this.params.Page = 1;
            this.getOrderList(true);
          }, 500);
        }
      } else {
        this.$toast.fail(res3.message || "接口失效，请稍后～");
        setTimeout(() => {
          this.params.Page = 1;
          this.getOrderList(true);
        }, 500);
      }
    },

    // 关闭弹窗
    handleClosePopup() {
      this.isShow = false;
      this.getOrderList(true);
    },
  },
};
</script>
<style lang='less' scoped>
.orderPage {
  padding-top: 40px;
  .search_wrap {
    width: 660px;
    height: 80px;
    border: 1px solid rgba(173, 173, 173, 0.76);
    border-radius: 45px;
    margin: auto;
    background: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
    margin-bottom: 25px;
    /deep/ .van-cell {
      padding: 0;
      background: none;
      flex-shrink: 0;
      border: none;
      flex: 1;
    }
    /deep/ .van-field__control {
      text-align: center;
    }
    .search_btn {
      flex-shrink: 0;
      width: 70px;
      .iconfont {
        font-size: 40px;
        color: #d6d0d1;
      }
    }
  }
  .select_wrap {
    width: 660px;
    margin: auto;
    box-sizing: border-box;
    .dropdown_wrap {
      width: 500px;
      flex-shrink: 0;
    }
    .select_item {
      margin-top: 20px;
      height: 80px;
      border-bottom: 1px dashed #2c2b2b;
      font-size: 30px;
      color: #333333;
      padding: 0 14px;
      .icon-toTop {
        transform: rotate(180deg);
        font-size: 20px;
      }
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
    }
    /deep/ .van-dropdown-menu__title {
      width: 280px;
      box-sizing: border-box;
      text-align: center;
      padding: 0 30px 0 15px;
    }
    /deep/ .van-dropdown-menu__title::after {
      right: 20px;
      border-color: transparent transparent #c4c5c6 #c4c5c6;
    }
    .search_btn {
      flex-shrink: 0;
      width: 160px;
      font-size: 24px;
      background: #096f70;
      color: #fff;
      margin-left: 10px;
      white-space: nowrap;
      height: 90px;
      .iconfont {
        font-size: 28px;
        margin-left: 5px;
      }
    }
  }
  .radio_wrap {
    font-size: 24px;
    color: #1e1e1e;
    margin: 25px auto;
    span {
      margin-left: 16px;
    }
  }
  .clear_condition {
    width: 200px;
    height: 60px;
    background: #ffffff;
    border: 3px solid #096f70;
    border-radius: 35px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
    text-align: center;
    line-height: 60px;
  }
  .order_num {
    width: 660px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
  }
  .order_wrap {
    margin-top: 25px;
    height: 73vh;
    overflow-y: scroll;
    .list {
      .item {
        width: 660px;
        // min-height: 700px;
        background: #ffffff;
        border: 6px solid #e6e6e6;
        border-radius: 40px;
        margin: 0 auto 30px;
        padding: 52px 44px;
        box-sizing: border-box;
        font-size: 28px;
        color: #040000;
        .block_one {
          font-size: 30px;
          margin-bottom: 45px;
          .column {
            &:nth-child(2n) {
              margin: 10px 0;
            }
            .label {
              width: 140px;
            }
            .con {
              color: #ff0000;
            }
          }
        }
        .block_two {
          // margin-bottom: 99px;
          font-size: 28px;
          position: relative;
          .column {
            &:last-child {
              margin-bottom: 0;
            }
          }
          .order_state_operation {
            // position: absolute;
            // bottom: 0;
            // right: -30px;
            margin-top: 30px;
            .btn {
              width: 130px;
              height: 40px;
              background: #096f70;
              border-radius: 45px;
              text-align: center;
              font-size: 20px;
              color: #fff;
              &.disabled {
                background: #9e9e9e;
              }
            }
          }
        }

        .column {
          align-items: flex-start;
          &:nth-child(2n) {
            margin: 26px 0;
          }
          .left {
            align-items: flex-start;
            .con {
              width: 320px;
              flex-shrink: 0;
            }
          }
          .label {
            white-space: nowrap;
            width: 180px;
            flex-shrink: 0;
          }
          .con {
            word-wrap: break-word;
            flex-shrink: 0;
            width: 380px;
            span {
              margin-left: 10px;
            }
          }
          .iconfont {
            font-size: 30px;
          }
          &.order_content {
            .con {
              flex-shrink: 0;
              width: 270px;
            }
          }
        }
      }
    }
  }
  /deep/ .van-popup--bottom {
    bottom: 80px;
  }
  .custom_popup {
    width: 650px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -51%);
    .custom_close {
      position: fixed;
      right: 0;
      top: -70px;
      .iconfont {
        font-size: 52px;
        color: #fff;
        // font-weight: bold;
      }
    }
    .custom_popup_wrap {
      background: #ffffff;
      overflow-y: scroll;
      height: 84vh;
      .list {
        .item {
          // width: 660px;
          // min-height: 700px;
          // background: #ffffff;
          // border: 6px solid #e6e6e6;
          // border-radius: 40px;
          // margin: 0 auto 30px;
          // padding: 52px 44px 0;
          // box-sizing: border-box;
          // font-size: 28px;
          // color: #040000;
          margin: 0 auto 240px;
          padding: 52px 44px 0;
          box-sizing: border-box;
          font-size: 28px;
          color: #040000;
          .block_one {
            font-size: 30px;
            margin-bottom: 65px;
            .column {
              .label {
                width: 140px;
              }
              .con {
                color: #ff0000;
              }
            }
          }
          .block_two {
            margin-bottom: 99px;
          }
          .block_three {
            margin-bottom: 85px;
          }
          .btn {
            margin-bottom: 60px;
          }
          .column {
            align-items: flex-start;
            &:nth-child(2n) {
              margin: 26px 0;
            }
            .label {
              white-space: nowrap;
              width: 190px;
              flex-shrink: 0;
            }
            .con {
              word-wrap: break-word;
              flex-shrink: 0;
              width: 380px;
            }
          }
        }
      }
    }
  }

  /deep/ .van-popup {
    background: transparent;
  }
  .popup_container {
    position: relative;
    // height: 600px;
    padding-bottom: 100px;
    box-sizing: border-box;
    .popup_wrap {
      width: 660px;
      // height: 500px;
      box-sizing: border-box;
      padding: 30px 0;
      background: #fff;
      .btn_item {
        width: 600px;
        height: 150px;
        border: 1px solid #a0a0a0;
        font-size: 30px;
        padding: 0 60px 0 68px;
        box-sizing: border-box;
        margin: 0 auto 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .icon-youjiantou {
          font-size: 30px;
          color: #515151;
        }
      }
      .textarea_box {
        border-radius: 0;
        margin-bottom: 40px;
        padding: 15px 20px;
        box-sizing: border-box;
        /deep/ .van-cell {
          padding: 0;
          width: 100%;
          height: 100%;
        }
        /deep/ .van-field__body {
          height: 100%;
        }
        /deep/ .van-field__control {
          height: 100%;
        }
      }
      .custom_btn {
        background: #373737;
        position: relative;
        .icon-yuyinjiantou {
          position: absolute;
          transform: rotate(-90deg);
          right: 20px;
        }
      }
    }
    .close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      .iconfont {
        font-size: 50px;
        color: #fff;
      }
    }
  }
}
</style>